"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { createPortal } from "react-dom";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { DropLocation } from "@/components/waves/drops/Drop";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import MemesLeaderboardDropCard from "./MemesLeaderboardDropCard";
import MemesLeaderboardDropHeader from "./MemesLeaderboardDropHeader";
import MemesLeaderboardDropDescription from "./MemesLeaderboardDropDescription";
import MemesLeaderboardDropVoteSummary from "./MemesLeaderboardDropVoteSummary";
import MemesLeaderboardDropArtistInfo from "./MemesLeaderboardDropArtistInfo";
import MemeDropTraits from "./MemeDropTraits";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import WaveDropActionsOptions from "@/components/waves/drops/WaveDropActionsOptions";
import WaveDropActionsOpen from "@/components/waves/drops/WaveDropActionsOpen";
import { VotingModal, MobileVotingModal } from "@/components/voting";
import VotingModalButton from "@/components/voting/VotingModalButton";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import useLongPressInteraction from "@/hooks/useLongPressInteraction";
import CommonDropdownItemsMobileWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsMobileWrapper";
import WaveDropMobileMenuDelete from "@/components/waves/drops/WaveDropMobileMenuDelete";
import WaveDropMobileMenuOpen from "@/components/waves/drops/WaveDropMobileMenuOpen";
import Link from "next/link";
import { formatNumberWithCommas } from "@/helpers/Helpers";
interface MemesLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly location?: DropLocation;
}
export const MemesLeaderboardDrop: React.FC<MemesLeaderboardDropProps> = t0 => {
  const $ = _c(98);
  const {
    drop,
    onDropClick,
    location: t1
  } = t0;
  const location = t1 === undefined ? DropLocation.WAVE : t1;
  const isMobileScreen = useIsMobileScreen();
  const {
    canDelete
  } = useDropInteractionRules(drop);
  const [isVotingModalOpen, setIsVotingModalOpen] = useState(false);
  const {
    hasTouchScreen
  } = useDeviceInfo();
  let t2;
  if ($[0] !== hasTouchScreen) {
    t2 = {
      hasTouchScreen
    };
    $[0] = hasTouchScreen;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    isActive,
    setIsActive,
    touchHandlers
  } = useLongPressInteraction(t2);
  let t3;
  if ($[2] !== drop.metadata) {
    t3 = drop.metadata?.find(_temp)?.data_value ?? "Artwork Title";
    $[2] = drop.metadata;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const title = t3;
  let t4;
  if ($[4] !== drop.metadata) {
    t4 = drop.metadata?.find(_temp2)?.data_value ?? "This is an artwork submission for The Memes collection.";
    $[4] = drop.metadata;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const description = t4;
  let t5;
  if ($[6] !== drop.parts) {
    t5 = drop.parts.at(0)?.media.at(0);
    $[6] = drop.parts;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const artworkMedia = t5;
  let t6;
  if ($[8] !== drop.top_raters) {
    t6 = drop.top_raters?.slice(0, 3) ?? [];
    $[8] = drop.top_raters;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const firstThreeVoters = t6;
  let t7;
  if ($[10] !== drop || $[11] !== hasTouchScreen || $[12] !== onDropClick) {
    t7 = () => !hasTouchScreen && onDropClick(drop);
    $[10] = drop;
    $[11] = hasTouchScreen;
    $[12] = onDropClick;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== drop) {
    t8 = <MemesLeaderboardDropArtistInfo drop={drop} />;
    $[14] = drop;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== canDelete || $[17] !== drop || $[18] !== hasTouchScreen) {
    t9 = !hasTouchScreen && <><WaveDropActionsOpen drop={drop} />{canDelete && <WaveDropActionsOptions drop={drop} />}</>;
    $[16] = canDelete;
    $[17] = drop;
    $[18] = hasTouchScreen;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9) {
    t10 = <div className="tw-flex tw-gap-2 tw-text-iron-400">{t9}</div>;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t8) {
    t11 = <div className="tw-p-4 tw-pb-3 tw-border-b tw-border-solid tw-border-x-0 tw-border-t-0 tw-border-white/5 tw-bg-iron-900/30"><div className="tw-flex tw-items-start tw-justify-between tw-gap-4">{t8}{t10}</div></div>;
    $[22] = t10;
    $[23] = t8;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== title) {
    t12 = <MemesLeaderboardDropHeader title={title} />;
    $[25] = title;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== description) {
    t13 = <MemesLeaderboardDropDescription description={description} />;
    $[27] = description;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t12 || $[30] !== t13) {
    t14 = <div className="tw-px-4 tw-pt-4 tw-pb-4"><div className="tw-space-y-1">{t12}{t13}</div></div>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== artworkMedia || $[33] !== location) {
    t15 = artworkMedia && <div className={`tw-flex tw-justify-center tw-h-96 ${location === DropLocation.WAVE ? "tw-bg-iron-950" : "tw-bg-iron-900/40"}`}><DropListItemContentMedia media_mime_type={artworkMedia.mime_type} media_url={artworkMedia.url} isCompetitionDrop={true} /></div>;
    $[32] = artworkMedia;
    $[33] = location;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== drop) {
    t16 = <MemeDropTraits drop={drop} />;
    $[35] = drop;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== drop.context_profile_context || $[38] !== drop.raters_count || $[39] !== drop.rating || $[40] !== drop.rating_prediction || $[41] !== drop.wave.voting_credit_type || $[42] !== firstThreeVoters) {
    t17 = <MemesLeaderboardDropVoteSummary current={drop.rating} projected={drop.rating_prediction} creditType={drop.wave.voting_credit_type} ratersCount={drop.raters_count} topVoters={firstThreeVoters} userContext={drop.context_profile_context} />;
    $[37] = drop.context_profile_context;
    $[38] = drop.raters_count;
    $[39] = drop.rating;
    $[40] = drop.rating_prediction;
    $[41] = drop.wave.voting_credit_type;
    $[42] = firstThreeVoters;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== firstThreeVoters) {
    t18 = firstThreeVoters.map(_temp5);
    $[44] = firstThreeVoters;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== t18) {
    t19 = <div className="tw-flex tw-items-center -tw-space-x-2">{t18}</div>;
    $[46] = t18;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== drop.raters_count) {
    t20 = formatNumberWithCommas(drop.raters_count);
    $[48] = drop.raters_count;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  const t21 = drop.raters_count === 1 ? "voter" : "voters";
  let t22;
  if ($[50] !== t21) {
    t22 = <span className="tw-text-iron-500 tw-font-normal">{t21}</span>;
    $[50] = t21;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== t20 || $[53] !== t22) {
    t23 = <span className="tw-text-white tw-font-bold tw-text-xs">{t20}{" "}{t22}</span>;
    $[52] = t20;
    $[53] = t22;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  if ($[55] !== t19 || $[56] !== t23) {
    t24 = <div className="tw-flex @[700px]:tw-hidden tw-items-center tw-gap-2">{t19}{t23}</div>;
    $[55] = t19;
    $[56] = t23;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  let t25;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = () => setIsVotingModalOpen(true);
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  let t26;
  if ($[59] !== drop) {
    t26 = <VotingModalButton drop={drop} onClick={t25} />;
    $[59] = drop;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  let t27;
  if ($[61] !== t24 || $[62] !== t26) {
    t27 = <div className="tw-flex tw-w-full @[700px]:tw-w-auto tw-items-center tw-justify-between @[700px]:tw-justify-end tw-gap-4 tw-flex-shrink-0" onClick={_temp3}>{t24}{t26}</div>;
    $[61] = t24;
    $[62] = t26;
    $[63] = t27;
  } else {
    t27 = $[63];
  }
  let t28;
  if ($[64] !== t17 || $[65] !== t27) {
    t28 = <div className="tw-flex tw-flex-col @[700px]:tw-flex-row @[700px]:tw-items-center tw-justify-between tw-gap-4">{t17}{t27}</div>;
    $[64] = t17;
    $[65] = t27;
    $[66] = t28;
  } else {
    t28 = $[66];
  }
  let t29;
  if ($[67] !== t16 || $[68] !== t28) {
    t29 = <div className="tw-p-4 tw-mt-4 tw-border-t tw-border-solid tw-border-x-0 tw-border-b-0 tw-border-white/5 tw-bg-iron-900/30 tw-flex tw-flex-col tw-gap-y-4">{t16}{t28}</div>;
    $[67] = t16;
    $[68] = t28;
    $[69] = t29;
  } else {
    t29 = $[69];
  }
  let t30;
  if ($[70] !== t11 || $[71] !== t14 || $[72] !== t15 || $[73] !== t29) {
    t30 = <div>{t11}{t14}{t15}{t29}</div>;
    $[70] = t11;
    $[71] = t14;
    $[72] = t15;
    $[73] = t29;
    $[74] = t30;
  } else {
    t30 = $[74];
  }
  let t31;
  if ($[75] !== drop || $[76] !== isMobileScreen || $[77] !== isVotingModalOpen) {
    t31 = isMobileScreen ? <MobileVotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} /> : <VotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} />;
    $[75] = drop;
    $[76] = isMobileScreen;
    $[77] = isVotingModalOpen;
    $[78] = t31;
  } else {
    t31 = $[78];
  }
  let t32;
  if ($[79] !== drop || $[80] !== t30 || $[81] !== t31) {
    t32 = <MemesLeaderboardDropCard drop={drop}>{t30}{t31}</MemesLeaderboardDropCard>;
    $[79] = drop;
    $[80] = t30;
    $[81] = t31;
    $[82] = t32;
  } else {
    t32 = $[82];
  }
  let t33;
  if ($[83] !== t32 || $[84] !== touchHandlers) {
    t33 = <div {...touchHandlers}>{t32}</div>;
    $[83] = t32;
    $[84] = touchHandlers;
    $[85] = t33;
  } else {
    t33 = $[85];
  }
  let t34;
  if ($[86] !== canDelete || $[87] !== drop || $[88] !== hasTouchScreen || $[89] !== isActive || $[90] !== setIsActive) {
    t34 = hasTouchScreen && createPortal(<CommonDropdownItemsMobileWrapper isOpen={isActive} setOpen={setIsActive}><div className="tw-grid tw-grid-cols-1 tw-gap-y-2"><WaveDropMobileMenuOpen drop={drop} onOpenChange={() => setIsActive(false)} />{canDelete && <WaveDropMobileMenuDelete drop={drop} onDropDeleted={() => setIsActive(false)} />}</div></CommonDropdownItemsMobileWrapper>, document.body);
    $[86] = canDelete;
    $[87] = drop;
    $[88] = hasTouchScreen;
    $[89] = isActive;
    $[90] = setIsActive;
    $[91] = t34;
  } else {
    t34 = $[91];
  }
  let t35;
  if ($[92] !== t33 || $[93] !== t34) {
    t35 = <div className="tw-w-full tw-group">{t33}{t34}</div>;
    $[92] = t33;
    $[93] = t34;
    $[94] = t35;
  } else {
    t35 = $[94];
  }
  let t36;
  if ($[95] !== t35 || $[96] !== t7) {
    t36 = <div className="tw-w-full tw-cursor-pointer tw-@container" onClick={t7}>{t35}</div>;
    $[95] = t35;
    $[96] = t7;
    $[97] = t36;
  } else {
    t36 = $[97];
  }
  return t36;
};
function _temp(m) {
  return m.data_key === "title";
}
function _temp2(m_0) {
  return m_0.data_key === "description";
}
function _temp3(e) {
  return e.stopPropagation();
}
function _temp4(e_0) {
  return e_0.stopPropagation();
}
function _temp5(voter) {
  return <Link key={voter.profile.handle} href={`/${voter.profile.handle}`} onClick={_temp4}>{voter.profile.pfp ? <img className="tw-w-6 tw-h-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800 tw-object-contain" src={voter.profile.pfp} alt="Recent voter" /> : <div className="tw-w-6 tw-h-6 tw-rounded-lg tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800" />}</Link>;
}